<template>  
    <div>
        <div>
            <div class="checkout-info">
                <div class="item-wrapper" v-for="(item, itemIndex) in items" :key="uniqueKey(item, itemIndex)">
                    <checkout-item
                        :isMinified="isMinified"
                        :key="itemIndex"
                        :index="itemIndex"
                        :item="item"
                        @incrementQuantity="increment(itemIndex)"
                        @decrementQuantity="decrement(itemIndex)"
                        @removeItem="removeFromCart(itemIndex)"
                        @editItem="editItem(itemIndex)"
                        @change="$emit('change')"
                        >
                    </checkout-item>
                </div>
				<template v-if="totals">
					<div v-for="(value, key) in streamLinedTotals" :key="key" class="checkout-total is-size-6">
						<p v-if="key !== 'subTotal'" :class="displayDiscountStyle(value)">
							<span class="has-text-grey is-bold">{{startCase(key)}}</span>
							<span class="is-pulled-right has-text-right">
								<strong>{{ centsToDollars(value) }}</strong>
							</span>
						</p>
					</div>
				</template>
            </div>
        </div>
        <v-dialog/>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { CART, ACCOUNT_CHECKOUT, RECENT_ORDERS, LOCATION, ACCOUNT } from '@/stores/defs';
	import EventBus from '@EventBus';
	import Formatter from "@/utils/Formatter";
    import {getParam} from "@/utils/helper.functions";
    import { EServiceType } from "@/models/interfaces/Orders/EServiceType";
    import orderService from '@/services/order.service';
    import EmptyCart from './EmptyCart.vue';
    import CheckoutItem from '@/components/checkout/CheckoutItem.vue';
    import offersMixin from '@Mixin/offersMixin';
	import couponMixin from '@Mixin/couponMixin';
	import cartItemMixin from '@Mixin/cartItemMixin';
    import checkoutMixin from '@Mixin/checkoutMixin';
    import checkoutPricesMixin from '@/components/mixins/checkoutPricesMixin';
    import { startCase } from "lodash";
    import eCommerceAnalyticsMixin from '@/components/mixins/eCommerceAnalyticsMixin';
	import { ECOMMERCE_ACTIONS } from '@/common/analytic-events/ecommerceActions';

    export default {
        props: {
            isMinified: {
                type: Boolean,
                default: false
            }
        },
        mixins: [
			cartItemMixin,
			checkoutMixin,
			offersMixin,
			couponMixin,
			checkoutPricesMixin,
			eCommerceAnalyticsMixin
		],
        data() {
            return {
                EServiceType: EServiceType,
                recentOrderParams: {
                    cmd: null,
                    orderId: null,
                    addedToCart: false
                }
            }
        },
        components: {
            'empty-cart': EmptyCart,
            'checkout-item': CheckoutItem,
        },
        computed: {
            ...mapGetters({
                items: CART.ITEMS,
                priceTotal: CART.PRICE,
                recentOrders: RECENT_ORDERS.GET_RECENT_ORDERS,
                checkoutTotal: CART.GET_CHECKOUT_TOTAL,
                serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
                totals: CART.GET_TOTALS,
                preorder: ACCOUNT_CHECKOUT.GET_PREORDER
            }),
        },
        created() {
            // get recentOrder parameters
            this.recentOrderParams.cmd = getParam("cmd");
            this.recentOrderParams.orderId= parseInt(getParam("order_id"));
        },
        watch: {
            recentOrders: function(recentOrders, isEmpty) {

                if (recentOrders.length && !this.recentOrderParams.addedToCart 
                    && this.recentOrderParams.cmd === "add" && this.recentOrderParams.orderId) {

                  const pastUserOrder = this.$store.getters["recentOrders/getRecentOrderById"](this.recentOrderParams.orderId);
                   if (pastUserOrder) {
                        for (let item of pastUserOrder.items) {
                            this.addOrderToCart(item);
                        }
                        this.recentOrderParams.addedToCart = true;
                    }
                }
            }
        },
        methods: {
            startCase: startCase,
            hasItems() {
                return (this.items.length > 0);
            },
            centsToDollars: Formatter.centsToDollars,
            ...mapActions({
                incrementItem: CART.INCREMENT_ITEM,
                decrementItem: CART.DECREMENT_ITEM,
                removeItem: CART.REMOVE_ITEM,
                setServiceType: ACCOUNT_CHECKOUT.SET_SERVICE_TYPE,
                addOrderToCart: CART.ADD_ITEM,
			}),
			uniqueKey(item, itemIndex) {
				const key = `${item.hash()}-${itemIndex}`;
				return key;
			},
			displayDiscountStyle(value) {
				return {
					'discounted--amount': Math.sign(value) === -1,
				};
			},
			displayCheckoutTotal() {
				let total = this.checkoutTotal;
				const discount = this.getDiscountTotal();
				total -= discount;
				return Formatter.centsToDollars(total);
			},
            setOrder(serviceType) {
                this.setServiceType(serviceType);
			},
            increment(index) {
				const item = this.items[index];
				item.invalidatePriceCache();
				this.incrementItem(item);
				EventBus.$emit('item-added-coupon');
				this.$tpa.trackCartAddItem(item.name);
            },
            decrement(index) {
				const item = this.items[index];
				item.invalidatePriceCache();
                if (item.quantity === 1) {
                    this.confirmItemDeletion(item);
                } else {
					this.decrementItem(item);
					EventBus.$emit('item-removed', item);
					this.$tpa.trackCartRemoveItem(item.name);
				}
            },
        },
    }
</script>

<style lang="scss">
@import "globalStyles";
    .item-wrapper {
        display: flex;
        flex-direction: row;
        
        margin: 0em 0em 1em 0em;
        padding-bottom: 1em;

        border-bottom: 1px solid #d0d0d0;
    }
    .checkout-item {
        display: flex;
        flex-direction: column;
    }

    .cart-checkout-wrapper {
        margin: 1em;
        padding-left: 5em;
        padding-top: 2.5em;
    }

    .checkout-info {
        border: 1px solid $greyOutline;
        padding: 1em;
        border-radius: 5px;
    }

</style>


// WEBPACK FOOTER //
// src/components/checkout/CheckoutSummary.vue